import { FormInputClearErrorsType, FormInputSetValueType } from '@/types'

const GENERATED_PASSWORD_LENGTH = 12

function passwordGenerator(len: number): string {
  const symbols = '!@#$%^&*()'
  const digits = '0123456789'
  const letters = 'abcdefghijklmnopqrstuvwxyz'
  const capitalLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

  const all = [symbols, digits, letters, capitalLetters]

  let password = [
    symbols[Math.floor(Math.random() * symbols.length)],
    digits[Math.floor(Math.random() * digits.length)],
    letters[Math.floor(Math.random() * letters.length)],
    capitalLetters[Math.floor(Math.random() * capitalLetters.length)],
  ]

  for (let i = 4; i < len; i++) {
    const currentCharset = all[Math.floor(Math.random() * all.length)]
    password.push(
      currentCharset[Math.floor(Math.random() * currentCharset.length)]
    )
  }

  password = password.sort(() => Math.random() - 0.5)

  return password.join('')
}

export const generatePassword = (
  setValue: FormInputSetValueType,
  clearErrors: FormInputClearErrorsType
) => {
  const generatedPassword = passwordGenerator(GENERATED_PASSWORD_LENGTH)

  setValue('password', generatedPassword, {
    shouldDirty: true,
    shouldTouch: true,
  })
  setValue('repeatPassword', generatedPassword, {
    shouldDirty: true,
    shouldValidate: true,
    shouldTouch: true,
  })

  clearErrors('password')
  clearErrors('repeatPassword')
}
